<template>
  <div class="category-list">
    <ul class="category-list__list">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="category-list__list__item"
        :class="{'category-list__list__item--active' : itemSelected == index}"
      >
        <button @click="select(item, index)">
          <slot v-bind:item="item" />
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      items: { type: Array, required: true }
    },

    data: () => ({
      itemSelected: null,
    }),

    methods: {
      select (item, itemSelected) {
        this.itemSelected = itemSelected
        this.$emit('select', item)
      },

      reset () {
        this.itemSelected = null
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .category-list {

    &__list {
      &__item {
        &:not(:last-child) {
          margin-bottom: 16px;
        }

        button {
          display: block;
          width: 100%;
          background: $purple20;
          padding: 8px 16px;
          text-align: left;
          border-radius: 36px;
        }


        button:hover,
        &--active button {
          background: $purple400;
          color: $white300;
        }
      }
    }
  }
</style>
